import maplibregl from 'maplibre-gl';

import { controls } from '../controls.config';
import MoreControl from './CustomControls/MoreControl';
import MeasurementControl from './CustomControls/MeasurementControl/MeasurementControl';
import MapLegend from './CustomControls/MapLegend/MapLegend';

async function mapToControlRef(control) {
  const {
    identifier,
    collapsed = false,
    options = {},
    position = 'top-right',
  } = control;

  const controlRef = {
    identifier,
    collapsed,
    position,
  }
  
  switch (identifier) {
    case 'navigation':
      return { 
        ...controlRef, 
        ref: new maplibregl.NavigationControl(options),
      };
    case 'geolocate':
      return { 
        ...controlRef, 
        ref: new maplibregl.GeolocateControl(options),
      };
    case 'attribution':
      return {
        ...controlRef,
        ref: new maplibregl.AttributionControl(options),
      }
    case 'measurement':
      return {
        ...controlRef,
        ref: new MeasurementControl(options),
      }
    case 'legend':
      return {
        ...controlRef,
        ref: new MapLegend(options),
      }
    case 'scale':
      return {
        ...controlRef,
        ref: new maplibregl.ScaleControl(options),
      }
    default: 
      return null;
  }
}

function addMoreControlRefsToMap(map, refs) {
  const topLeftRefs = refs.filter(curr => curr.position === 'top-left');
  const topRightRefs = refs.filter(curr => curr.position === 'top-right');
  const bottomLeftRefs = refs.filter(curr => curr.position === 'bottom-left');
  const bottomRightRefs = refs.filter(curr => curr.position === 'bottom-right');

  if (topLeftRefs.length) {
    map.addControl(new MoreControl({ controlRefs: topLeftRefs }), 'top-left');
  }
  
  if (topRightRefs.length) {
    map.addControl(new MoreControl({ controlRefs: topRightRefs }), 'top-right');
  }

  if (bottomLeftRefs.length) {
    map.addControl(new MoreControl({ controlRefs: bottomLeftRefs }), 'bottom-left');
  }

  if (bottomRightRefs.length) {
    map.addControl(new MoreControl({ controlRefs: bottomRightRefs }), 'bottom-right');
  }
}

/*  EXPORTS
    ================================================================================ */
async function addControlsToMap(map) {
  const controlRefs = await Promise.all(
    controls.filter(curr => !curr.collapsed).map(mapToControlRef),
  );
  const moreControlRefs = await Promise.all(
    controls.filter(curr => curr.collapsed).map(mapToControlRef),
  );

  controlRefs.forEach((curr) => {
    const { ref, position } = curr;
    
    map.addControl(ref, position);
  });

  addMoreControlRefsToMap(map, moreControlRefs);

  return [...controlRefs, ...moreControlRefs]
}

export {
  addControlsToMap,
}